import React from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import styles from './CargoMainInfoForm.module.css'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { NumberField } from 'components/Shared/NumberField'
import { ContainerColumn } from '../ContainerColumn'
import { ContainerRow } from '../ContainerRow'

export function CargoMainInfoForm ({ name, disabled }) {
  return (
    <ContainerColumn>
      <FieldComponent fieldName={`${name}.cargoDetails.name`} label={'form.order.cargo.name'} disabled={disabled}/>
      <FieldComponent fieldName={`${name}.cargoDetails.wrappingType`} label={'form.order.cargo.wrappingType'}
                      disabled={disabled}/>
      <ContainerRow>
        <NumberField
          fieldName={`${name}.cargoDetails.quantity`}
          label={'form.order.cargo.quantity'}
          className={styles.quantityField}
          disabled={disabled}/>
        <NumberField
          fieldName={`${name}.cargoDetails.weight`}
          label={'form.order.cargo.weight'}
          className={styles.weightField}
          endAdornment
          endAdornmentValue={<InputAdornment position="end">Kg</InputAdornment>}
          disabled={disabled}/>
      </ContainerRow>
      <FieldComponent fieldName={`${name}.cargoDetails.dispenser`} label={'form.order.cargo.dispenser'}
                      disabled={disabled}/>
      <FieldComponent
        fieldName={`${name}.additionalInfo`}
        label={'form.order.cargo.remarks'}
        multiline
        disabled={disabled}/>
    </ContainerColumn>
  )
}
